<template>
  <div :class="$options.name">
    <data-table
      ref="data-table"
      reference="data-table"
      :list="list"
      :headers="headers"
      :is-loading="isLoading"
      :options="{}"
      :items-per-page="12"
      :pagination="pagination"
      @change-page="onChangePage"
    >
      <template #toolbar>
        <div v-if="lastData">
          Последнее обновление: {{ lastData }}
        </div>
        <div class="flex-grow-1" />
        <v-text-field
          v-model="search"
          label="Поиск по названию"
          prepend-inner-icon="search"
          flat
          clearable
          single-line
          hide-details
        />
      </template>

      <template #item.state="{ item }">
        {{ STATES[item.state] }}
      </template>

      <template #item.orthophotomapUploadedAt="{ item }">
        {{ format(item.orthophotomapUploadedAt) }}
      </template>

      <template #item.actions="{ item }">
        <div class="d-flex">
          <v-btn
            :disabled="item.state !== 'prepared'"
            class="primary"
            small
            @click="loadOrthophotomap(item.id)"
          >
            Загрузить
          </v-btn>
          <v-btn
            small
            class="ml-2"
            @click="$router.push({ name: 'layers-item', params: { id: item.layerId } })"
          >
            Перейти к слою
          </v-btn>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import moment from 'moment';
import debounce from 'lodash/debounce';
import { mapActions, mapState } from 'vuex';
import DataTable from '@/components/common/data-table';

export default {
  name: 'obzor-orthophotomaps',
  asyncData({ store }) {
    const actions = [
      store.dispatch('gisObzor/getList'),
    ];

    return Promise.all(actions);
  },
  components: { DataTable },
  data: () => ({
    headers: [
      { value: 'name', text: 'Название', sortable: false },
      { value: 'state', text: 'Статус', sortable: false },
      { value: 'orthophotomapUploadedAt', text: 'Дата внесения информации', sortable: false },
      { value: 'actions', sortable: false, width: '20%' },
    ],
    isLoading: false,
    search: '',
    lastData: null,
  }),
  computed: {
    ...mapState('gisObzor', ['list', 'pagination']),

    format: () => (d) => (!d ? '-' : moment(d.date).format('DD.MM.YYYY HH:mm')),
  },
  watch: {
    search(query) {
      this.doSearch(query);
    },
  },
  created() {
    this.STATES = {
      prepared: 'Готов к загрузке',
      process: 'Загружается',
      built: 'Загружен',
    };

    this.lastData = this.list[0] && moment(this.list[0].createdAt.date).format('DD.MM.YYYY HH:mm');

    this.doSearch = debounce(async () => {
      await this.getList({ query: this.search });
    }, 750);
  },
  methods: {
    ...mapActions('gisObzor', ['getList', 'getNextPage', 'buildOrthophotomap']),
    ...mapActions(['showNotify']),

    async onChangePage(page) {
      this.isLoading = true;
      await this.getNextPage({ page });
      this.isLoading = false;
    },

    async loadOrthophotomap(id) {
      this.isLoading = true;
      try {
        await this.buildOrthophotomap(id);
        await this.getList();
        this.showNotify({ message: 'Процесс построения снимка запущен. Снимок будет доступен через несколько минут' });
      } catch (e) {
        this.showNotify({ message: 'Что-то пошло не так. Обратитесь к администратору', type: 'error' });
      }

      this.isLoading = false;
    },
  },
};
</script>

<style scoped>

</style>
